import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TenantService } from '../services/tenant.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private tenant: TenantService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    // 1. Must have a tenant selected
    if (!this.tenant.isSet) {
      this.router.navigate(['/select-instance']);
      return false;
    }
    // 2. Must be authenticated
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
